import React, {useEffect, useState} from "react";
import Menu from '@material-ui/core/Menu';
import Checkbox from '@material-ui/core/Checkbox';
import { green } from '@material-ui/core/colors' ;
import { withStyles } from '@material-ui/core/styles';
import Filter from "../../../assets/Images/reconcilation_filter.svg";

const GreenCheckbox = withStyles({
  root: {
    color: "#E2E8F0",
    '&$checked': {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const ReportFilter = ({filteredValue, setFilteredValue, searchStarted, setSearchStarted}) => {

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [checkBoxValue,setCheckBoxValue] = useState([
    {
      id: 1,
      isChecked: true,
      name: "matched",
      label: "Matched",
    },
    {
      id: 2,
      isChecked: true,
      name: "not_in_plan",
      label: "Not in Plan",
    },
    { 
      id: 3,
      isChecked: true,
      name: "additional",
      label: "Additional", 
    },
  ]);
  const [selectedValue, setSelectedValue] = useState(["matched", "not_in_plan", "additional"]);

  useEffect(() => {
    if(searchStarted) {
      let clonedCheckBoxValue = [...checkBoxValue]
      clonedCheckBoxValue.forEach((item) => {
        item.isChecked = true
      })
      setSelectedValue(["matched", "not_in_plan", "additional"])
      setCheckBoxValue(clonedCheckBoxValue)
      setSearchStarted(false)
    }
  },[searchStarted])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    let clonedCheckBoxValue = [...checkBoxValue]
    if(!filteredValue) {
      clonedCheckBoxValue.forEach((item) => {
        item.isChecked = true
      })
      setCheckBoxValue(clonedCheckBoxValue)
      setSelectedValue(["matched", "not_in_plan", "additional"])
    } else if(filteredValue?.length > 0) {
      clonedCheckBoxValue.forEach((item) => {
        if(filteredValue.includes(item.name)) {
          item.isChecked = true;
        } else {
          item.isChecked = false;
        }
      })
      setCheckBoxValue(clonedCheckBoxValue)
      setSelectedValue([...filteredValue])
    }
  };

  const handleCheckBoxChange = (id, name) => {
    let clonedCheckBoxValue = [...checkBoxValue]
    let clonedSelectedValue = [...selectedValue]
    clonedCheckBoxValue.forEach((input) => {
      if (input.id === id) {
          input.isChecked = !input.isChecked;
          if(input.isChecked) {
            clonedSelectedValue.push(name)
          }
          else {
            const index = clonedSelectedValue.indexOf(name)
            if(index > -1) {
              clonedSelectedValue.splice(index,1)
            }
          }
          setCheckBoxValue(clonedCheckBoxValue)
          setSelectedValue(clonedSelectedValue)
          return;
      }
    });
  };

  const handleSave = () => {
    setFilteredValue([...selectedValue])
    let clonedCheckBoxValue = [...checkBoxValue]
    clonedCheckBoxValue.forEach((item) => {
      if(selectedValue.includes(item.name)) {
        item.isChecked = true;
      } else {
        item.isChecked = false;
      }
    })
    setCheckBoxValue(clonedCheckBoxValue)
    setAnchorEl(null);
  }

  return (
    <>
      <div className="section-summary-details-filterimage">
        <img src={Filter} alt="Filter icon" onClick={handleClick} />
      </div>
      <Menu
        id="menu"
        keepMounted
        anchorEl={anchorEl}
        onClose={handleClose}
        open={Boolean(anchorEl)}
        getContentAnchorEl={null}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        PaperProps={{
          style: {
            borderRadius: "5px",
          },
        }}
      >
        <div className="report-filter-menu">
          { checkBoxValue.map((value,index) => {
            return(
              <div key={index} className="report-filter-menu-item">
                <div>{value.label}</div>
                <div>
                  <GreenCheckbox 
                    disableRipple
                    checked={value.isChecked}
                    onClick={() => handleCheckBoxChange(value.id,value.name)}
                    //onChange={(e) => handleCheckBoxChange(e,value.id,value.label)}
                  />
                </div>
              </div>
            )
          })
          }
          <div className="report-filter-menu-buttons">
            <div
              onClick={handleClose}
              className="report-filter-menu-button-cancel"
            >
              Cancel
            </div>
            <div
              onClick={handleSave}
              className="report-filter-menu-button-apply"
            >
              Apply Filter
            </div>
          </div>
        </div>
      </Menu>
    </>
  );
}

export default ReportFilter;